import { computed, signal, Signal } from '@angular/core';
import { search, SearchOptions } from '../functions/search.function';
import { ExplorerAddonFactory } from './explorer';

export interface SearchExplorer<T> {
  searchTerm: Signal<string | null>;
  searchOptions: Signal<SearchOptions | null>;
  result: Signal<T[]>;
  count: Signal<number>;
  search(searchTerm: string, options?: SearchOptions): void;
}

export interface SearchExplorerOptions {
  defaultSearchTerm?: string;
  defaultSearchOptions?: SearchOptions;
}

export function withSearch<T>(options?: SearchExplorerOptions): ExplorerAddonFactory<T, SearchExplorer<T>> {
  return (source: Signal<T[]>): SearchExplorer<T> => searchList<T>(source, options);
}

function searchList<T>(source: Signal<T[] | undefined>, options?: SearchExplorerOptions): SearchExplorer<T>{
  const searchTerm = signal<string | null>(options?.defaultSearchTerm ?? null)
  const searchOptions = signal<SearchOptions | null>(options?.defaultSearchOptions ?? null);
  const result = computed(() => {
    const items = source() ?? [];
    const term = searchTerm();
    const options = searchOptions();
    if(!term || term.length === 0)
      return items;
    return search(items, term, options);
  });
  return {
    searchTerm,
    searchOptions,
    result,
    count: computed(() => result().length),
    search(term: string, options?: SearchOptions) {
      searchTerm.set(term);
      searchOptions.set(options ?? null);
    }
  }
}
